// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centerbox {
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  align-self: center;
  background: rgb(69 69 69 / 28%);
  position: fixed;
  z-index: 9999999999999;
  top: 0;
  left: 0;
}

.favicon-loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.favicon-loader img {
  width: 46px;
  height: 46px;
  animation: faviconPulse 1.2s ease-in-out infinite;
}

@keyframes faviconPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.7;
  }
}

.rotate {
  border: 4px solid #7ED375;
  border-radius: 50%;
  width: 70px;
  /* animation: rotation 2s infinite linear; */
}

.rotates {
  border: 4px solid #7ED375;
  border-radius: 50%;
  width: 70px;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}



.loader {
  width: 48px;
  height: 48px;
  margin: auto;
  position: relative;
}

.loader:before {
  content: '';
  width: 48px;
  height: 5px;
  background: #7ED3754f;
  position: absolute;
  top: 60px;
  left: 0;
  border-radius: 50%;
  animation: shadow324 0.5s linear infinite;
}

.loader:after {
  content: '';
  width: 100%;
  height: 100%;
  background: #7ED375;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
  animation: jump7456 0.5s linear infinite;
}

@keyframes jump7456 {
  15% {
    border-bottom-right-radius: 3px;
  }

  25% {
    transform: translateY(9px) rotate(22.5deg);
  }

  50% {
    transform: translateY(18px) scale(1, .9) rotate(45deg);
    border-bottom-right-radius: 40px;
  }

  75% {
    transform: translateY(9px) rotate(67.5deg);
  }

  100% {
    transform: translateY(0) rotate(90deg);
  }
}

@keyframes shadow324 {

  0%,
  100% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(1.2, 1);
  }
}



.loader2 {
  background-color: #1111114d;
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: start;
  align-content: center;
  justify-content: flex-start;
  z-index: 100000;
}

.loader__element {
  height: 4.5px;
  width: 100%;
  background: #0000;

}

.loader__element:before {
  content: '';
  display: block;
  background-color: #7ED375;
  height: 4.5px;
  width: 0;
  animation: getWidth 2s ease-in infinite;
}

@keyframes getWidth {
  100% {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/customComponents/Loading/Loading.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,sDAAsD;IACtD,gCAAgC;EAClC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;;EAEE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;;;AAIA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;;AAEnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,QAAQ;EACR,uCAAuC;AACzC;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".centerbox {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  background: rgb(69 69 69 / 28%);\n  position: fixed;\n  z-index: 9999999999999;\n  top: 0;\n  left: 0;\n}\n\n.favicon-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.favicon-loader img {\n  width: 46px;\n  height: 46px;\n  animation: faviconPulse 1.2s ease-in-out infinite;\n}\n\n@keyframes faviconPulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.15);\n    opacity: 0.7;\n  }\n}\n\n.rotate {\n  border: 4px solid #7ED375;\n  border-radius: 50%;\n  width: 70px;\n  /* animation: rotation 2s infinite linear; */\n}\n\n.rotates {\n  border: 4px solid #7ED375;\n  border-radius: 50%;\n  width: 70px;\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n\n\n.loader {\n  width: 48px;\n  height: 48px;\n  margin: auto;\n  position: relative;\n}\n\n.loader:before {\n  content: '';\n  width: 48px;\n  height: 5px;\n  background: #7ED3754f;\n  position: absolute;\n  top: 60px;\n  left: 0;\n  border-radius: 50%;\n  animation: shadow324 0.5s linear infinite;\n}\n\n.loader:after {\n  content: '';\n  width: 100%;\n  height: 100%;\n  background: #7ED375;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 4px;\n  animation: jump7456 0.5s linear infinite;\n}\n\n@keyframes jump7456 {\n  15% {\n    border-bottom-right-radius: 3px;\n  }\n\n  25% {\n    transform: translateY(9px) rotate(22.5deg);\n  }\n\n  50% {\n    transform: translateY(18px) scale(1, .9) rotate(45deg);\n    border-bottom-right-radius: 40px;\n  }\n\n  75% {\n    transform: translateY(9px) rotate(67.5deg);\n  }\n\n  100% {\n    transform: translateY(0) rotate(90deg);\n  }\n}\n\n@keyframes shadow324 {\n\n  0%,\n  100% {\n    transform: scale(1, 1);\n  }\n\n  50% {\n    transform: scale(1.2, 1);\n  }\n}\n\n\n\n.loader2 {\n  background-color: #1111114d;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: start;\n  align-content: center;\n  justify-content: flex-start;\n  z-index: 100000;\n}\n\n.loader__element {\n  height: 4.5px;\n  width: 100%;\n  background: #0000;\n\n}\n\n.loader__element:before {\n  content: '';\n  display: block;\n  background-color: #7ED375;\n  height: 4.5px;\n  width: 0;\n  animation: getWidth 2s ease-in infinite;\n}\n\n@keyframes getWidth {\n  100% {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
